
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__graduation-cap-check",
  "use": "icon__graduation-cap-check-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"icon__graduation-cap-check\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M.5 0h24v24H.5z\" /><path d=\"m12.5 2.941 12 4.805v1.6L20 10.922v6.375l-.458.278c-.562.32-3.546 1.925-7.042 1.925-3.362 0-6.25-1.483-6.966-1.882l-.16-.092-.374-.23v-6.374L2 9.867V19.5H.5V7.746l12-4.805zm3.97 5.529L11 13.94l-2.47-2.47-1.06 1.06 3.532 3.53 6.528-6.53-1.06-1.06zM1.25 21a.748.748 0 0 0-.75.75c0 .416.334.75.75.75s.75-.334.75-.75a.748.748 0 0 0-.75-.75z\" fill=\"currentColor\" /></g></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconGraduationCapCheckIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__graduation-cap-check" {...restProps} />
    })
  